<template>
    <div class="circle-section">
        <div class="border-circle" :style="{clipPath: clipPathValue, backgroundColor: color}"></div>
        <div class="circle-info">
            <div class="value" :style="{color: color}">{{resourceNumber}}</div>
            <div class="text">{{text}}</div>
        </div>
    </div>
</template>

<script>

export default {

    components: {

    },

    props: {
        percent: {
            type: Number,
            required: true
        },
        resourceNumber: {
            type: Number,
            required: true
        },
        text: {
            type: String,
            required: true
        },
        color: {
            type: String,
            required: true
        }
    },

    data: function(){
        return {

        };
    },

    computed: {
        // le clip path est composé d'un centre et de 6 points,
        // Le centre et le premier point ne changeront jamais de valeur,
        // le remplissage selon le pourcentage est géré par les autres points
        // et est décrit ci-dessous
        // les coordonnées sont exprimées par x y qui sont en %,
        // le coin haut gauche vaut 0% 0% (ou 0 0)
        // le coin bas droit vaut 100% 100%
        // un point non utilisé est placé au centre (50% 50%)
        // si le pourcentage est supérieur à la fourchette de pourcentage géré
        // par un point, la valeur max lui est alors attribuée
        //
        // - Point 2:
        //     - valeur min: 50% 0
        //     - valeur max: 100% 0
        //     - pourcentage géré: 0% 12.5%

        // - Point 3:
        //     - valeur min: 100% 0
        //     - valeur max: 100% 100%
        //     - pourcentage géré: 12.5% 37.5%

        // - Point 4:
        //     - valeur min: 100% 100%
        //     - valeur max: 0 100%
        //     - pourcentage géré: 37.5% 62.5%

        // - Point 5:
        //     - valeur min: 0 100%
        //     - valeur max: 0 0
        //     - pourcentage géré: 62.5% 87.5%

        // - Point 6:
        //     - valeur min: 0 0
        //     - valeur max: 50% 0
        //     - pourcentage géré: 87.5% 100%
        // .____.._____.
        // |           |
        // |           |
        // |     x     |
        // |           |
        // .___________.
        centerPoint() {
            return '50% 50%';
        },
        firstPoint() {
            return '50% 0';
        },
        secondPoint() {
            if (this.percent <= 12.5) {
                return `${50 + 4 * this.percent}% 0`
            } else {
                return '100% 0';
            }
        },
        thirdPoint() {
            if (this.percent <= 37.5) {
                return `100% ${4 * (this.percent - 12.5)}%`
            } else {
                return '100% 100%';
            }
        },
        fourthPoint() {
            if (this.percent <= 62.5) {
                return `${100 - 4 * (this.percent - 37.5)}% 100%`
            } else {
                return '0 100%';
            }
        },
        fifthPoint() {
            if (this.percent <= 87.5) {
                return `0 ${100 - 4 * (this.percent - 62.5)}%`
            } else {
                return '0 0';
            }
        },
        sixthPoint() {
            return `${50 + 2 * (this.percent - 87.5)}% 0`
        },
        clipPathValue() {
            return `polygon(${
                this.centerPoint
            },${
                this.firstPoint
            },${
                this.secondPoint
            },${
                this.percent > 12.5 ? this.thirdPoint : this.centerPoint
            },${
                this.percent > 37.5 ? this.fourthPoint : this.centerPoint
            },${
                this.percent > 62.5 ? this.fifthPoint : this.centerPoint
            },${
                this.percent > 87.5 ? this.sixthPoint : this.centerPoint
            })`
        }

    },

    mounted: function(){

    },

    methods: {
    },
};
</script>

<style lang="scss">
.circle-section {
    height: 60px;
    width: 60px;
    border-radius: 60px;
    position: relative;
    background-color: rgba(255, 255, 255, 0.2);
    @media (min-width: 1025px) {
        height: 100px;
        width: 100px;
        border-radius: 100px;
    }
    .border-circle {
        position: absolute;
        height: 60px;
        width: 60px;
        border-radius: 60px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        @media (min-width: 1025px) {
            height: 100px;
            width: 100px;
            border-radius: 100px;
        }
    }
    .circle-info {
        position: absolute;
        height: 50px;
        width: 50px;
        border-radius: 50px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: #222;
        @media (min-width: 1025px) {
            height: 90px;
            width: 90px;
            border-radius: 90px;
        }
        .value {
            position: absolute;
            font-size: 20px;
            top: 50%;
            left: 50%;
            font-weight: 500;
            transform: translate(-50%, -50%);
        }
        .text {
            position: absolute;
            bottom: -35px;
            font-size: 15px;
            left: 50%;
            font-weight: 500;
            transform: translate(-50%, 0);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/layout-indicator.vue